import { render, staticRenderFns } from "./products-query-ranking-modal.vue?vue&type=template&id=803f4308&scoped=true"
import script from "./products-query-ranking-modal.vue?vue&type=script&lang=ts"
export * from "./products-query-ranking-modal.vue?vue&type=script&lang=ts"
import style0 from "./products-query-ranking-modal.vue?vue&type=style&index=0&id=803f4308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803f4308",
  null
  
)

export default component.exports